module.exports = __webpack_public_path__ + "static/media/brl_coin_25.b81cb6bf.png";